export default {
    PERMISSION: 'permission'
}